/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { FormControl, ValidatorFn } from '@angular/forms';
import { convertHtmlToPlainText } from '@ng-falcon/+utils/convert-html-to-plain-text-fn';

export const notBlank: ValidatorFn =
  (control: FormControl<string | null>) => {
    if (control.value === null) {
      return { isBlank: true };
    }

    if (typeof control.value !== 'string') {
      throw Error(`[notBlank] expected value of type string, but got value of type: ${typeof control.value}`);
    }

    return convertHtmlToPlainText(control.value).trim().length > 0
      ? null
      : { isBlank: true };
  };
